module.exports = __webpack_public_path__ + "static/media/Slice7@2x.a39dbb8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice7@2x.png
// module id = 1436
// module chunks = 0